import { IncorrectTypeError } from './incorrect-type-error';

export function assertIsNumber(num: unknown, error?: string): asserts num is number {
  if (isNaN(Number(num))) {
    throw new IncorrectTypeError(error || `Number required, received ${JSON.stringify(num)}`);
  }
}
